import type { Hit as AlgoliaHit } from "algoliasearch";
import type { Hit as InstantsearchHit } from "instantsearch.js";
import { useMemo } from "react";
import type { AlgoliaAttributes } from "../types/AlgoliaAttributes";

type EnrichHit<T> = T extends InstantsearchHit<AlgoliaAttributes>
    ? InstantsearchHit<ItemboxAttributes>
    : T extends AlgoliaHit<AlgoliaAttributes>
        ? AlgoliaHit<ItemboxAttributes>
        : never;

export function useEnrichedProducts<
    T extends InstantsearchHit<AlgoliaAttributes> | AlgoliaHit<AlgoliaAttributes>
>(items: T[]): EnrichHit<T>[] {
    return useMemo(() => items as EnrichHit<T>[], [items]);
}
